import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Provider } from 'react-redux';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './redux/store';
import './fonts/Audiowide-Regular.ttf';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import { createRoot } from "react-dom/client";

// Only enable on Chrome/desktop for debugging, disable on Firefox mobile due to severe performance impact
if (process.env.REACT_APP_NODE_ENV === 'development' && !navigator.userAgent.includes('Firefox')) {
  whyDidYouRender(React);
}

// ReactDOM.render(
//   // <React.StrictMode>
//     <Provider store={store}>
//       <App nameEntered={false} />
//     </Provider>,
//   // </React.StrictMode>,
//   document.getElementById('root')
// );

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<Provider store={store}><App /></Provider>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
